import { LIST_SHIPPING_REQUEST, RESET_SHIPPING_QUERY } from './constants';

export const listShippingRates = () => ({
  type: LIST_SHIPPING_REQUEST
});

export const resetShippingRatesQuery = () => ({
  type: RESET_SHIPPING_QUERY
});
